function distributeurController(DatatableLang, $localStorage, $state, $scope, WS, $filter, $window, AppSettings) {
    'ngInject';
    const vm = this;
    vm.distributeurs = {};
    vm.detail = {};
    vm.files = [];
    //vm.center = AppSettings.mapsalgerie;
    vm.keymaps = AppSettings.keymaps;

    WS.getScache('pays').then(function(response) {
        vm.getpays = response.data;
        vm.center = vm.getpays.latitude + ', ' + vm.getpays.longitude;
        $scope.$apply();
    }, function(error) {
        console.log(error);
    });

    vm.selectedSocietes = function() {
        WS.get('societes/selectedSocietes')
            .then(function(response) {
                if (response.status == 200) {
                    vm.socs = response.data;
                    $scope.$apply();
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
            });
    };

    vm.get = function() {
        WS.get('distributeurs')
            .then(function(response) {
                if (response.status == 200) {
                    vm.distributeurs = response.data;
                    $scope.$apply();
                    $('.table_distributeurs').DataTable({
                        "language": DatatableLang
                    });
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
            });
    };
    vm.getDetails = function(id) {
        WS.get('distributeurs/' + $state.params.id)
            .then(function(response) {
                if (response.status == 200) {
                    vm.detail = response.data;
                    $scope.$apply();
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
            });
    }

    vm.store = function() {
        //vm.detail.logo = vm.files[0];
        var route;
        var method;
        var msg;
        console.log(vm.detail);
        if ($state.params.id) {
            route = 'distributeurs/' + $state.params.id;
            method = 'PUT';
            msg = 'modifiée';
        } else {
            route = "distributeurs";
            method = "POST";
            msg = 'ajoutée';
        }

        WS.postwithimg(route, vm.detail, method)
            .then(function(data) {
                if (data.status == 200) {
                    swal(
                        'Succès',
                        'distributeur ' + msg + ' avec succées',
                        'success'
                    ).then(function() {
                        $window.location.reload();
                    });
                } else {}
            }, function(error) {
                console.log(error);
            });
    };

    $scope.uploadedFile = function(element) {
        $scope.currentFile = element.files[0];
        var reader = new FileReader();
        reader.onload = function(event) {
            vm.detail.logo = event.target.result
            $scope.$apply(function() {
                vm.files = element.files;
            });
        }
        reader.readAsDataURL(element.files[0]);
    }

    vm.save = function(detail) {
        WS.post('distributeurs', vm.detail)
            .then(function(response) {
                if (response.status == 200) {
                    swal(
                        'Succès',
                        'distributeur ajoutée avec Succès',
                        'success'
                    ).then(function() {
                        $window.location.reload();
                    });

                } else {}
            })
            .then(null, function(error) {
                console.log(error);
                swal(
                    'ERROR !',
                    error.data.message,
                    'error'
                )

            });
    }
    vm.update = function(detail) {

        WS.put('distributeurs/' + $state.params.id, vm.detail)
            .then(function(response) {
                if (response.status == 200) {
                    swal(
                        'Succée',
                        'distributeur mis à jour avec succées',
                        'success'
                    )
                    window.location.reload();
                } else {}
            })
            .then(null, function(error) {
                console.log(error);
                swal(
                    'ERROR !',
                    error.data.message,
                    'error'
                )

            });
    }

    vm.delete = function(id) {
        swal({
            title: 'distributeur',
            text: "voulez vous vraiment supprimer ce distributeur!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non',
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-danger',
            buttonsStyling: false
        }).then(function() {
            WS.delete('distributeurs/' + id).then(
                function() {
                    swal(
                        'Succée',
                        'distributeur supprimée avec Succée',
                        'success'
                    ).then(function() {
                        $window.location.reload();
                    });
                },
                function() {
                    swal(
                        'Attention',
                        'vous ne pouvez pas supprimer ce distributeur!',
                        'warning'
                    );
                }
            );
        }, function(error) {
            console.log(error);
        });
    }
}
export default {
    name: 'distributeurController',
    fn: distributeurController
};